<template lang="pug">
modal#remove-user-modal(
  :buttonColor='true'
  :close-button-label='$t("button.cancel")'
  :loading='loading'
  :process-button-label='$t("button.remove")'
  :title='$t("modal.removeUser.title")'
  @process='removeUser'
  ref='modal'
)
  .span.text {{ $t('modal.removeUser.message') }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';
import TeamsService from '@/modules/business/services/http/organizations/teams/TeamsService';
import UsersService from '@/modules/business/services/http/organizations/users/UsersService';
import RolesService from '@/modules/business/services/http/organizations/roles/RolesService';

export default {
  name: 'RemoveUserModal',
  props: {
    teamId: [Number, String],
    userId: [Number, String],
    roleId: [Number, String],
    operation: Boolean,
  },
  components: {
    Modal,
    ImageLoader,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async removeUser() {
      this.loading = true;
      if (this.operation) {
        await UsersService.remove(this.userId).then(() => {
          this.closeModal();
        });
      } else if (this.teamId != null) {
        await TeamsService.deleteUser(this.teamId, this.userId).then(() => {
          this.closeModal();
        });
      } else {
        await RolesService.removeUser(this.roleId, this.userId).then(() => {
          this.closeModal();
        });
      }
    },
    closeModal() {
      this.$emit('refresh');
      this.loading = false;
      this.$refs.modal.close();
    },
  },
};
</script>
